import { useEffect, useState } from "react";
import { IContainerApp } from "../navigationButtonComponents/loansTab/containerApp/IContainerApp";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import ViewContract from "./viewContract";
import SignContract from "./signContract";
import { IFormInnerState } from "../requestSteps/form/IFormInnerState";
import Accept from "../loanResult/accept";
import Reject from "../loanResult/reject";
import { TContractState } from "./IContract";
export default function WaitSign({ referenceKey, setStep }: IFormInnerState) {
    const [state, setState] = useState<TContractState>('viewContract');
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as TContractState;

    useEffect(() => {
        if (stateFromRedux === 'viewContract')
            setState('viewContract')
    }, [stateFromRedux]);
    const innerStep = {
        viewContract: <ViewContract setState={setState} referenceKey={referenceKey} />,
        signContract: <SignContract setState={setState} referenceKey={referenceKey} setStep={setStep} />,
        accept: <Accept />,
        reject: <Reject />,
    }

    return (
        <div>
            {innerStep[state]}
        </div>
    )
}
